import { fg } from '@atlassian/jira-feature-gating';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { assetsDataManagerObjectClassViewRoute } from '@atlassian/jira-router-routes-assets-data-manager-routes/src/assetsDataManagerObjectClassViewRoute.tsx';
import { createChromelessEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import {
	toPackageName,
	APP_NAMES,
} from '@atlassian/jira-servicedesk-common/src/utils/app-names/index.tsx';
import { getAssetsAppResources } from '@atlassian/jira-router-routes-servicedesk-cmdb-entries/src/common/getCmdbResources.tsx';
import { LazyAssetsLayout, AssetsLayout } from '@atlassian/jira-assets-layout/src/ui/async.tsx';
import { AssetsPageConfigContainer } from '@atlassian/jira-assets-app-page-config-container/src/ui/async.tsx';
import Spinner from '@atlassian/jira-common-components-spinner/src/view.tsx';
import { assetsDataManagerObjectClassViewEntryPoint } from '@atlassian/jira-spa-apps-assets-data-manager-object-class-view/entrypoint.tsx';

const assetsDataManagerObjectClassViewPageEntryPoint = createChromelessEntryPoint({
	main: assetsDataManagerObjectClassViewEntryPoint,
});

export const assetsDataManagerObjectClassViewRouteEntry = createEntry(
	assetsDataManagerObjectClassViewRoute,
	() => ({
		group: 'assets',
		LayoutOverrideComponent: AssetsLayout,
		PageConfigContainerOverride: AssetsPageConfigContainer,
		skeleton: Spinner,
		perfMetricKey: 'assets-data-manager-object-class-view',
		pageId: () => 'spa-apps/assets-data-manager-object-class-view',
		resources: getAssetsAppResources(),
		forPaint: [LazyAssetsLayout],

		entryPoint() {
			return fg('assets_data_manager_jira_spa')
				? assetsDataManagerObjectClassViewPageEntryPoint
				: undefined;
		},

		component: fg('assets_data_manager_jira_spa') ? undefined : ErrorPagesNotFound,

		meta: {
			reporting: {
				id: APP_NAMES.ASSETS_APP_DATA_MANAGER_OBJECT_CLASS_VIEW_PAGE,
				packageName: toPackageName(APP_NAMES.ASSETS_APP_DATA_MANAGER_OBJECT_CLASS_VIEW_PAGE),
				teamName: 'Aurum',
			},
		},

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-assets-data-manager-entries/src/assetsDataManagerObjectClassViewRouteEntry.tsx',
				whichExportToUse: 'assetsDataManagerObjectClassViewRouteEntry',
			},

			enabled: true,
		},
	}),
);
